import appStore from 'store';
import api from './api';

const store = {

    namespaced : true,

    state : {
        supportCoins: [],
    },

    mutations : {
        setSupportCoins(state,payload) {
            state.supportCoins = payload;
        }
    },

    actions : {

        getSupportCoins({commit}) {
            api.getAllSupportCoins().then(response => {
                commit('setSupportCoins',response.data);
            })
        },

        setWalletCoins({commit},data){
            return api.configWalletCoins(data);
        },

        setInnerCoins({commit},data) {
            return api.configInnerCoins(data);
        },
        setAirdropCoins({commit},data) {
            return api.configAirDropCoins(data);
        }
    }

}

appStore.registerModule('transfer',store);